module.exports = __webpack_public_path__ + "img/20_pc.9c440b6b.gif";